import { PLOT_VIEWER } from "../constants";

const initialState = {
  plotImageDataByFilename: [],
  plotViewerImageData: [],
  plotViewerLoading: false,
  plotViewerError: "",
};

export default function plotViewerReducer(state = initialState, action) {
  switch (action.type) {
    case PLOT_VIEWER.SET_PLOT_IMAGE_DATA_BY_FILENAME:
      return {
        ...state,
        plotImageDataByFilename: action.payload,
      };
    case PLOT_VIEWER.SET_PLOT_VIEWER_IMAGE_DATA:
      return {
        ...state,
        plotViewerImageData: action.payload,
      };
    case PLOT_VIEWER.SET_PLOT_VIEWER_LOADING:
      return {
        ...state,
        plotViewerLoading: action.payload,
      };
    case PLOT_VIEWER.SET_PLOT_VIEWER_ERROR:
      return {
        ...state,
        plotViewerError: action.payload,
      };
    default:
      return state;
  }
}
